/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";

const AddWebpageButton = (props) => {
    const setOpen = props?.setOpen;

    const openDialog = () => {
        if (setOpen) {
            setOpen(true);
        }
    };

    return (
        <div 
            className="banner-add-webpage-button"
            onClick={openDialog}
        >
            <div className="banner-add-webpage-button-text">Select Webpage</div>
        </div>
    );
};

AddWebpageButton.displayName = "AddWebpageButton";
export { AddWebpageButton };

